import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { API_IDS } from '@intigral/constant';
import { INotificationsRepository } from '../../core/repositories/interfaces/iNotificationsRepository';
import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IApiPathManager } from '../config/ApiPathManager';

class NotificationsRepository implements INotificationsRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get appKey(): string {
        return process.env['NX_PUBLIC_APP_KEY'] || 'APP_KEY';
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async validateVOCToken(token: string, apiToken: { [key: string]: string }): Promise<any> {
        const path = this.apiPathManager.getPath(API_IDS.NOTIFICATIONS_VALIDATE_VOC_TOKEN);
        const response = await this.http.post<any>(path, {
            params: {
                appKey: this.appKey,
            },
            body: {
                token,
                ...apiToken,
            },
            withCredentials: true,
        });
        return response.data;
    }
}

export default NotificationsRepository;
